<div class="row justify-content-center">
  <div class="col-12 col-xl-6">
    <div class="card dashboard-card">
      <app-slider></app-slider>
    </div>
  </div>
  <div class="col-12 col-xl-4">
    <div class="card card-primary dashboard-card">
      <div class="card-header">
        <h4 class="card-title w-100">
          <span>
            Business At-A-Glance
            {{ asOfDate ? "&nbsp;&nbsp;&nbsp;[ as of " + asOfDate + " ]": "Loading..."}}
          </span>
        </h4>
      </div>
      <div class="card card-secondary dashboard-card">
        <div class="card-body pb-1 mb-0">
          <div class="row justify-content-center" *ngIf="!(kpis$ | async)">
            <component-loading></component-loading>
          </div>
          <div *ngIf="(kpis$ | async)" style="overflow-x:scroll; height: 314px;">
            <div class="dashboard-headertext text-left">
              Visit <b>My Briefcase</b> for full performance metrics
              </div>
              <!--<ag-grid-angular style="height: 300px;"-->
              <ag-grid-angular class="ag-theme-alpine dashboard-grid"
                               [rowData]="kpis$ | async"
                               [columnDefs]="kpiColumnDefs"
                               [defaultColDef]="defaultColumnDef"
                               [autoGroupColumnDef]="autoGroupColumnDef"
                               [groupDefaultExpanded]="groupDefaultExpanded"
                               rowSelection='none'
                               [getRowHeight]="getRowHeight"
                               [suppressRowHoverHighlight]="true"
                               (gridReady)="onGridReady($event)"
                               [overlayNoRowsTemplate]="noRowsTemplate"
                               [ag-grid-resize]
                               [headerHeight]="0">
              </ag-grid-angular>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
